import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { MdRefresh } from 'react-icons/md';
import { DateTime } from 'luxon';
import { useAsync, asyncState } from '~/hooks';


const RefreshIndicator = ({ fetch }) => {
    const [lastUpdated, setLastUpdated] = useState(DateTime.now());

    const refresh = useAsync(async () => {
        await fetch();
        setLastUpdated(DateTime.now());
    }, false);


    return (
        <div className='flex items-center text-sm mr-auto py-2'>
            <p className="font-bold my-2">Last Updated</p>
            <p className="ml-2">{lastUpdated.toFormat("DD 'at' tt")}</p>
            {refresh.status == asyncState.PENDING 
                ? <AiOutlineLoading3Quarters className='text-blue-50 animate-spin ml-4'/>
                : (
                    <button 
                        className="flex items-center justify-center text-blue-50 font-semibold py-2 ml-4 focus:outline-none"
                        onClick={() => refresh.execute()}
                    >
                        <MdRefresh className="mr-1" size="1.25em"/>
                        Refresh
                    </button>
                )
            }
        </div>
    );
};

RefreshIndicator.propTypes = {
    fetch: PropTypes.func
};

export default RefreshIndicator;